import { authStore } from './auth.store';
export class IdentityService {
    constructor(_provider) {
        this._provider = _provider;
    }
    async signIn() {
        const user = await this._provider.signIn();
        authStore.setState({
            userId: user.uid,
            isGuest: user.isAnonymous,
            isAuthenticated: true,
        });
    }
    async signOut() {
        await this._provider.signOut();
        authStore.setState({ userId: null, isGuest: false, isAuthenticated: false });
    }
}
